import type { EntityConfig } from '../types'

export const paymentEntity: EntityConfig = {
  id: 'payment',
  displayName: 'Payment',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'succeeded', label: 'Succeeded' },
      { value: 'refunded', label: 'Refunded' },
      { value: 'disputed', label: 'Disputed' },
      { value: 'failed', label: 'Failed' },
      { value: 'uncaptured', label: 'Uncaptured' },
    ],
    options: [
      { value: 'succeeded', label: 'Succeeded', color: 'success' },
      { value: 'approved', label: 'Approved', color: 'success' },
      { value: 'verified', label: 'Verified', color: 'success' },
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'processing', label: 'Processing', color: 'pending' },
      { value: 'pending', label: 'Pending', color: 'pending' },
      { value: 'processing_partial_capture', label: 'Processing (Partial Capture)', color: 'pending' },
      { value: 'paying_out', label: 'Paying Out', color: 'pending' },
      { value: 'partially_paid', label: 'Partially Paid', color: 'warning' },
      { value: 'refunded', label: 'Refunded', color: 'info' },
      { value: 'refund_processing', label: 'Refund Processing', color: 'pending' },
      { value: 'refund_declined', label: 'Refund Declined', color: 'error' },
      { value: 'refund_blocked', label: 'Refund Blocked', color: 'error' },
      { value: 'sending_for_refund', label: 'Sending for Refund', color: 'pending' },
      { value: 'refund_denied', label: 'Refund Denied', color: 'error' },
      { value: 'partially_refunded', label: 'Partially Refunded', color: 'warning' },
      { value: 'refund_failed', label: 'Refund Failed', color: 'error' },
      { value: 'disputed', label: 'Disputed', color: 'error' },
      { value: 'uncaptured', label: 'Uncaptured', color: 'warning' },
      { value: 'failed', label: 'Failed', color: 'error' },
      { value: 'declined', label: 'Declined', color: 'error' },
      { value: 'canceled', label: 'Canceled', color: 'error' },
      { value: 'blocked', label: 'Blocked', color: 'error' },
      { value: 'expired', label: 'Expired', color: 'error' },
      { value: 'default', label: 'Default', color: 'neutral' },
    ],
    mappings: {
      all: [],
      succeeded: ['succeeded', 'processing_partial_capture', 'paying_out', 'partially_paid'],
      refunded: ['refund_processing', 'refund_declined', 'refund_failed', 'refund_blocked', 'sending_for_refund', 'refunded', 'partially_refunded', 'refund_denied'],
      disputed: ['disputed'],
      failed: ['canceled', 'blocked', 'failed', 'declined', 'expired'],
      uncaptured: ['uncaptured', 'processing_partial_capture', 'partially_paid'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    amount: { type: 'amount', urlKey: 'amount' },
    currency: { type: 'string_array', urlKey: 'currency' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'dateRange',
    'amount',
    'currency',
    'status',
    'paymentMethod',
  ]
}
